import qs from "qs";
import Cookie from "js-cookie";
import { UTM_STR } from "@/constants/cookieAndLsName";

type IUtmParams = {
  [key: string]: string;
};

function getParamUtmObj(paramStr: string): IUtmParams | null {
  const parseParams = qs.parse(paramStr, {
    ignoreQueryPrefix: true,
  });
  const utmParams: IUtmParams = {};
  let hasUtm = false;
  Object.keys(parseParams).forEach((p) => {
    if (p.toLowerCase().indexOf("utm_") === 0) {
      hasUtm = true;
      utmParams[p.toLowerCase()] = <string>parseParams[p];
    }
  });
  if (hasUtm) {
    return utmParams;
  }
  return null;
}

export const getUtm = () => {
  let searchUtmObj = getParamUtmObj(window.location.search);
  if (!searchUtmObj) {
    // 再检查 Cookie
    const cookieString = Cookie.get(UTM_STR) || "";
    searchUtmObj = getParamUtmObj(cookieString);
  }
  return searchUtmObj;
};

/**
 * 从 URL 当中获取当前的 UTM_*, 并且将其设置到 Cookie 当中
 * @method setUtm
 */
export const setUtm = () => {
  const utmParams = getParamUtmObj(window.location.search);
  if (!!utmParams) {
    Cookie.set(UTM_STR, qs.stringify(utmParams), {
      path: "/",
      domain: ".chereads.com",
      expires: 30,
    });
  }
};
